/**
 * Investor Portal Query Keys
 *
 * Portal-specific query keys for React Query
 */

export const portalQueryKeys = {
  // Portal root
  all: ['portal'] as const,

  capital: {
    all: () => [...portalQueryKeys.all, 'capital'] as const,
    summary: () => [...portalQueryKeys.capital.all(), 'summary'] as const,
    fundDetails: () =>
      [...portalQueryKeys.capital.all(), 'fundDetails'] as const,
    callHistory: (filters?: Record<string, unknown>) =>
      [...portalQueryKeys.capital.all(), 'callHistory', filters] as const,
    distributionHistory: (filters?: Record<string, unknown>) =>
      [
        ...portalQueryKeys.capital.all(),
        'distributionHistory',
        filters,
      ] as const,
  },

  holdings: {
    all: () => [...portalQueryKeys.all, 'holdings'] as const,
    summary: () => [...portalQueryKeys.holdings.all(), 'summary'] as const,
    byFund: (fundId?: string) =>
      [...portalQueryKeys.holdings.all(), 'fund', fundId] as const,
  },

  transactions: {
    all: () => [...portalQueryKeys.all, 'transactions'] as const,
    drawdowns: (filters?: Record<string, unknown>) =>
      [...portalQueryKeys.transactions.all(), 'drawdowns', filters] as const,
    distributions: (filters?: Record<string, unknown>) =>
      [
        ...portalQueryKeys.transactions.all(),
        'distributions',
        filters,
      ] as const,
    paymentsLastUpdated: () =>
      [...portalQueryKeys.transactions.all(), 'paymentsLastUpdated'] as const,
  },

  dashboard: {
    all: () => [...portalQueryKeys.all, 'dashboard'] as const,
    summary: () => [...portalQueryKeys.dashboard.all(), 'summary'] as const,
    recentActivity: () =>
      [...portalQueryKeys.dashboard.all(), 'recentActivity'] as const,
  },

  investors: {
    all: () => [...portalQueryKeys.all, 'investors'] as const,
    list: () => [...portalQueryKeys.investors.all(), 'list'] as const,
  },

  documents: {
    all: () => [...portalQueryKeys.all, 'documents'] as const,
    list: () => [...portalQueryKeys.documents.all(), 'list'] as const,
    byFund: (fundId?: string) =>
      [...portalQueryKeys.documents.all(), 'fund', fundId] as const,
    downloadUrl: (documentId?: string) =>
      [...portalQueryKeys.documents.all(), 'download', documentId] as const,
  },

  emails: {
    all: () => [...portalQueryKeys.all, 'emails'] as const,
    list: (params?: Record<string, unknown>) =>
      [...portalQueryKeys.emails.all(), 'list', params] as const,
    detail: (emailId?: string) =>
      [...portalQueryKeys.emails.all(), 'detail', emailId] as const,
  },

  me: () => [...portalQueryKeys.all, 'me'] as const,

  carry: {
    all: () => [...portalQueryKeys.all, 'carry'] as const,
    funds: () => [...portalQueryKeys.carry.all(), 'funds'] as const,
    holdings: () => [...portalQueryKeys.carry.all(), 'holdings'] as const,
    holding: (fundId: string) =>
      [...portalQueryKeys.carry.holdings(), fundId] as const,
    holdingPortfolio: (fundId: string) =>
      [...portalQueryKeys.carry.holding(fundId), 'portfolio'] as const,
    documents: () => [...portalQueryKeys.carry.all(), 'documents'] as const,
    fundDocuments: (fundId: string) =>
      [...portalQueryKeys.carry.documents(), fundId] as const,
    structure: () => [...portalQueryKeys.carry.all(), 'structure'] as const,
  },

  session: {
    all: () => [...portalQueryKeys.all, 'session'] as const,
    info: () => [...portalQueryKeys.session.all(), 'info'] as const,
  },
} as const;
